<template>
  <ag-modal-container
    :title="$t('trainingsession.title.createSession')"
    width="900px"
    @close="back"
  >
    <template v-if="companyTokenBalance">
      <v-alert
        text
        color="info"
        type="info"
        prominent
        class="text-center"
      >
        <h3 class="headline mr-10 pr-5" v-text="tokenBalanceMessage" />
      </v-alert>

      <session-form
        v-if="hasAllNeededList"
        :multi-project-version-list="multiProjectVersionList"
        :multi-project-draw-list="multiProjectDrawList"
        :on-time-version-list="onTimeVersionList"
        :multi-task-settings="multiTaskSettings"
        :max-players-available="companyTokenBalance"
        @validate="isValid = $event"
        @input="value = $event"
      />
    </template>

    <template v-else>
      <v-alert
        text
        color="error"
        type="error"
        prominent
        class="text-center"
      >
        <div class="mr-10 pr-5">
          <h3 class="headline" v-text="$t('trainingsession.token.emptyBalance')" />
        </div>
      </v-alert>

      <div v-if="canAskToken" class="text-center">
        <v-btn
          class="mt-5"
          color="accent"
          to="/tokens/demands/ask"
          v-text="$t('trainingsession.token.goToDemandPage')"
        />
      </div>
    </template>

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.create')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import { mapActions, mapGetters } from 'vuex'
import Repositories from 'src/repositories'
import SessionForm from '../components/SessionForm'

export default {
  name: 'SessionCreateContainer',
  components: {
    AgModalContainer,
    SessionForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    multiProjectVersionList: null,
    multiProjectDrawList: null,
    onTimeVersionList: null,
    multiTaskSettings: null,
    value: null,
  }),
  computed: {
    ...mapGetters('me', {
      companyTokenBalance: 'companyTokenBalance',
      roles: 'roles',
    }),
    canAskToken () {
      return this.roles.includes('OWNER') || this.roles.includes('ADMIN')
    },
    hasAllNeededList () {
      return !!this.multiProjectVersionList
        && !!this.multiProjectDrawList
        && !!this.onTimeVersionList
    },
    tokenBalanceMessage () {
      const balance = this.companyTokenBalance
      return this.$tc('trainingsession.token.balance', balance, { balance })
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler () {
        const [
          multiProjectVersionList,
          multiProjectDrawList,
          onTimeVersionList,
          multiTaskSettings,
        ] = await Promise.all([
          Repositories.multiProject.version.getList(),
          Repositories.multiProject.draw.getList(),
          Repositories.ontime.version.getList(),
          Repositories.multiTask.settings.get(),
          this.refreshCompany(),
        ])

        this.multiProjectVersionList = multiProjectVersionList
        this.multiProjectDrawList = multiProjectDrawList
        this.onTimeVersionList = onTimeVersionList
        this.multiTaskSettings = multiTaskSettings
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    ...mapActions('me', {
      refreshCompany: 'refreshCompany',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.trainingSession.session.post(this.value)
        this.showSuccessNotification(this.$t('trainingsession.fields.success.sessionCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
